import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../../app.config';
import { urlJoin } from '../../../core/helpers/url.helper';
import { Observable, ReplaySubject } from 'rxjs';
import { UserNotificationsPreferences, UserTablePreferences } from './preferences.model';
import { createHeaders } from '@tribeauto/ngx-mobilite-material';

@Injectable({
  providedIn: 'root'
})
export class PreferencesService {
  private readonly httpClient = inject(HttpClient);
  private readonly appConfig = inject(AppConfig);
  private readonly url = urlJoin(this.appConfig.url, 'admin/user/preferences');
  recordsPreferencesValidSubject = new ReplaySubject<boolean>(1);

  getUserRecordsPreferences(): Observable<UserTablePreferences> {
    return this.httpClient.get<UserTablePreferences>(urlJoin(this.url, 'records'), {
      headers: createHeaders()
    });
  }

  updateUserRecordsPreferences(userRecordsPreferencesRequest: UserTablePreferences): Observable<void> {
    return this.httpClient.post<void>(urlJoin(this.url, 'records'), userRecordsPreferencesRequest, {
      headers: createHeaders()
    });
  }

  getUserNotificationsPreferencesList(): Observable<UserNotificationsPreferences[]> {
    return this.httpClient.get<UserNotificationsPreferences[]>(urlJoin(this.url, 'notifications'), {
      headers: createHeaders()
    });
  }

  updateUserNotificationsPreferences(userNotificationsPreferences: UserNotificationsPreferences): Observable<void> {
    return this.httpClient.post<void>(urlJoin(this.url, 'notifications'), userNotificationsPreferences, {
      headers: createHeaders()
    });
  }

  updateRecordsPreferencesValid(value: boolean): void {
    this.recordsPreferencesValidSubject.next(value);
  }
}
